import { HeaderLayout } from "@/components/_layout/header-layout";
import { Link } from "@/components/navigation-controls/link";
import { IndicatorListTitleView } from "@/domain/indicator/components/indicator-list-title-view";
import { useCurrentIndicatorListContext } from "@/domain/indicator/hooks/use-current-indicator-list-context";
import { UserFavoriteButton } from "@/domain/user/components/user-favorite-button";
import { useCurrentWorkspaceContext } from "@/domain/workspace/hooks/useCurrentWorkspaceContext";

import { IndicatorCreateDialog } from "../components/indicator-create-dialog";
import { IndicatorDatatable } from "../components/indicator-datatable/indicator-datatable";

const VIEW_KEY = "Workspace:IndicatorList";
const PAGE_NAME = "Indikatoren";

export const IndicatorListPage = () => {
  const { currentWorkspace } = useCurrentWorkspaceContext();
  const { currentIndicatorList } = useCurrentIndicatorListContext();

  return (
    <div className="flex h-full w-full flex-row">
      <div className="flex h-full max-h-full w-full flex-col overflow-y-hidden">
        <HeaderLayout showNavigationControls={true}>
          <div className="flex flex-row items-center gap-2">
            <Link to={`/${currentWorkspace.workspaceUrl}/indicators`}>
              <IndicatorListTitleView />
            </Link>
            <UserFavoriteButton pageName={PAGE_NAME} />
          </div>
          <div className="flex flex-row items-center gap-2">
            <IndicatorCreateDialog workspace={currentWorkspace} />
          </div>
        </HeaderLayout>

        <IndicatorDatatable indicatorList={currentIndicatorList} workspace={currentWorkspace} viewKey={VIEW_KEY} />
      </div>
    </div>
  );
};
